import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * StreamTranslationView 组件
 * 用于实时显示流式翻译输出，带有自动滚动和光标闪烁效果
 *
 * @example
 * ```tsx
 * // 基本用法 - 显示流式翻译结果
 * <StreamTranslationView
 *   text="正在生成的翻译内容..."
 *   isStreaming={true}
 *   targetLanguage="zh-CN"
 * />
 *
 * // 静态显示 - 翻译结束后
 * <StreamTranslationView
 *   text="已完成的翻译内容"
 *   isStreaming={false}
 *   targetLanguage="zh-CN"
 * />
 * ```
 */
import { useEffect, useState } from 'react';
/**
 * 流式翻译结果展示组件
 * 展示实时生成的翻译内容，带有自动滚动和光标闪烁效果
 */
export const StreamTranslationView = ({ text, isStreaming, targetLanguage, }) => {
    // 用于控制光标闪烁动画的状态
    const [showCursor, setShowCursor] = useState(true);
    // 光标闪烁效果
    useEffect(() => {
        // 如果不在流式传输中，不显示光标
        if (!isStreaming) {
            setShowCursor(false);
            return;
        }
        // 设置光标闪烁的定时器
        const cursorInterval = setInterval(() => {
            setShowCursor(prev => !prev);
        }, 500); // 每500ms切换一次光标显示状态
        // 清理函数，组件卸载或依赖变化时清除定时器
        return () => clearInterval(cursorInterval);
    }, [isStreaming]);
    return (_jsx("div", { className: "bg-white rounded-lg shadow-md h-[20px] flex items-center p-2 overflow-hidden", children: _jsx("div", { className: "w-full overflow-hidden", style: { direction: 'rtl' }, children: _jsxs("div", { className: "inline-flex items-center text-sm text-interactive-stone-gray whitespace-nowrap", style: { direction: 'ltr', textAlign: 'left' }, children: [text ||
                        (isStreaming ? ('') : (_jsx("span", { className: "text-gray-500 italic", children: "Awaiting translation..." }))), isStreaming && showCursor && (_jsx("span", { className: "inline-block w-2 h-4 bg-interactive-emerald-flash ml-1 animate-pulse" }))] }) }) }));
};
// 添加默认导出以兼容旧代码
export default StreamTranslationView;
//# sourceMappingURL=StreamTranslationView.js.map